import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=06590b6e&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=06590b6e&prod&lang=scss"
import style1 from "./Shipments.vue?vue&type=style&index=1&id=06590b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06590b6e",
  null
  
)

export default component.exports